(function($){

	/* Get accurate Viewport sizing (no jQuery) */
    var viewportwidth;
    var viewportheight;

    function getWindowSize(){
        if (typeof window.innerWidth != 'undefined'){
            viewportwidth = window.innerWidth,
            viewportheight = window.innerHeight
        }else if (typeof document.documentElement != 'undefined' && typeof document.documentElement.clientWidth != 'undefined' && document.documentElement.clientWidth != 0){
            viewportwidth = document.documentElement.clientWidth,
            viewportheight = document.documentElement.clientHeight
        }else{
            viewportwidth = document.getElementsByTagName('body')[0].clientWidth,
            viewportheight = document.getElementsByTagName('body')[0].clientHeight
        }
    }

    /*
     *
     * Equal Height jQuery Snippet.  Using this for footer and grid accordion
     *
     */
    var equalheight = function (container){

        var currentTallest = 0,
            currentRowStart = 0,
            rowDivs = [],
            $el,
            topPosition = 0,
            currentDiv;
    
        $(container).each(function () {

            $el = $(this);
            $el.height('auto');
            topPosition = $el.position().top;

            if (currentRowStart < topPosition - 1 || currentRowStart > topPosition + 1) {
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                    rowDivs[currentDiv].height(currentTallest);
                }
                rowDivs = [];
                currentRowStart = topPosition;
                currentTallest = $el.height();
                rowDivs.push($el);
            }
            else {
                rowDivs.push($el);
                currentTallest = Math.max(currentTallest, $el.height());
            }
        });
        
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            rowDivs[currentDiv].css('height', currentTallest);
        }
    };
    

	function setupCountdown(){
		var current_date = new Date(),
			data = {};

		//loop through the countdown timers and get the next one that has not passed
		for( var i in UGACountdowns ){
			var timer_date = new Date( UGACountdowns[i].timer_date * 1000 );
			if( timer_date < current_date ){
				continue;
			}

			var data = UGACountdowns[i];
			break;
		}

		//set up text and initialize the timer
		$(".countdown-title").text( data.title );
		$(".countdown-url").text( data.button_text ).attr('href',data.button_target);
		var ts = new Date( ( data.timer_date * 1000 ) );

        $('#countdown').countdown({
            timestamp	: ts,
            callback	: function(days, hours, minutes, seconds){

                var message = "";

                message += days + " day" + ( days==1 ? '':'s' ) + ", ";
                message += hours + " hour" + ( hours==1 ? '':'s' ) + ", ";
                message += minutes + " minute" + ( minutes==1 ? '':'s' ) + " and ";
                message += seconds + " second" + ( seconds==1 ? '':'s' ) + " <br />";
            }
        });
	}

    function arrowClicks(){
        $('.nav-menu li .arrow').not('li li .arrow').on('click',function(e) {
            e.preventDefault();
            $(this).toggleClass('active').next().slideToggle();
        });
        $('.nav-menu .sub-menu li .arrow').on('click',function(e) {
            e.preventDefault();
            $(this).next().addClass('active');
            $(this).parents('.menu-item').css('position','static');
        });
        $('.sidr__menu-back').on('click',function(){
            var menuCloseId = $( this).data('sidr-menu');
            var menuId = menuCloseId.substring(5, menuCloseId.length);
            
            $('#'+menuCloseId).removeClass('active');
            $(this).parents('.menu-item').css('position','relative');
        });
    }
    
    function breakdownTabs(){
        $('.tab-stats').find('.tab-stats--container').hide().each(function(i){
            if ( i === 0 ) {
                var $attr = $(this).parents('.tab-stats').attr('id');
                $(this).addClass('active').show();
                $('.tab-stats#' + $attr).addClass('active');
            }
        });
        $('.breakdown-tab--tabs').find('li').each(function(i){
            if ( i === 0 ) {
                $(this).addClass('active');
            }
            $(this).on('click',function(){
                var $attr = $(this).data('tab');
                $('.breakdown-tab--tabs').find('li').removeClass('active');
                $('.tab-stats').removeClass('active').find('.tab-stats--container').removeClass('active').hide();

                $(this).addClass('active');
                $('.tab-stats#' + $attr).addClass('active').show().find('.tab-stats--container').show().addClass('active');

            });
        });
        $('.tab-stats--toggle').each(function(){
            $(this).on('click',function(){
                var $attr = $(this).data('title');
                $('.breakdown-tab--tabs').find('li').removeClass('active');
                $('.tab-stats').removeClass('active').find('.tab-stats--container').removeClass('active').hide();

                $('.breakdown-tab--tabs').find('li[data-tab="' + $attr + '"]').addClass('active');
                $('.tab-stats#' + $attr).addClass('active').show().find('.tab-stats--container').show().addClass('active');

            });
        });
    }
    
    function deadlineTabs(){
        /*
         * Deadlines
         */
        if ( $( ".deadlines" ).length ) {

            $('.deadlines').find('.deadlines--content').filter(':not(.active)').hide();

            $('.deadlines--tabs').find('li').each(function(i){
                if ( $(this).hasClass('active') ) {
                    var $attr = $(this).attr('data-title');
                    $('.deadlines--select').find('.links-select[data-select="' + $attr + '"]').addClass('active');
                }
                
                $(this).on('click',function(){
                    var $attr = $(this).attr('data-title');
                    if (history.pushState) {
                    	history.pushState( null , $(this).data('metatitle'), $(this).data('href') );
                    	document.title = $(this).data('metatitle');
					}
                    
                    $('.deadlines--select').each(function(){
                        $('.links-select').find('option:eq(0)').attr('selected','selected');
                    });
                    
                    $('.deadlines--tabs').find('li').removeClass('active');
                    $('.deadlines--select').find('.links-select').removeClass('active');
                    $('.deadlines--content').removeClass('active').hide();

                    $(this).addClass('active');
                    $('.deadlines--select').find('.links-select[data-select="' + $attr + '"]').addClass('active');
                });
            });
            
            $('.deadlines--select .links-select').each(function(){

                $(this).on('change',function() {
                    var $value = $(this).val(),
                    	option = $(this).children("option:selected");
                    if (history.pushState) {
                    	history.pushState( null , option.data('metatitle'), option.data('href') );
                    	document.title = option.data('metatitle');
					}
                    
                    $('.deadlines--content').removeClass('active').hide();
                    $('#' + $value).show().addClass('active');
                });
            });
            
            

        }
    }
    function deadlinesList(){
        var $prev_list_height = '',
            $curr_list_height = '';

        $('.deadlines--list').find('.list').each(function(){
            
            var $total_children = $(this).children('a').length; 
            
            $(this).find('a').each(function(i){
                $curr_list_height = $(this).offset().top;

                if(i === 0 ){
                    $prev_list_height = $(this).offset().top;
                    $(this).addClass('first');
                    
                    if(i === $total_children - 1){
                        $(this).addClass('last');
                    }
                }
                if($prev_list_height < $curr_list_height){
                    $prev_list_height = $(this).offset().top;
                    
                    $(this).prev().addClass('last');
                    $(this).addClass('first');
                }else{
                    $(this).prev().removeClass('last');
                    $(this).removeClass('first');
                    
                    if(i === 0 ){
                        $(this).addClass('first');
                        
                        if(i === $total_children - 1){
                            $(this).addClass('last');
                        }
                    }
                }

            });

        });
    }
    
    function stickyNav(){
        var scrollTop = $(window).scrollTop(),
            mobile = ( viewportwidth < 1024 ) ? true : false,
            size = $('#masthead').outerHeight(true),
            headerSub = '';
        
        if( viewportwidth < 1024 ){
            if( viewportwidth < 768 ){
                headerSub = '31';
            }else{
                headerSub = '41';
            }
        }else{
            headerSub = '43';
        }
        
        var bodyMargin = parseInt(headerSub) + parseInt(size) + 'px';

		if (scrollTop > headerSub) {

			$('#masthead, .sidr, .search--header').addClass('sticky');
            $('body').addClass('sticky');
            $('#page').css('margin-top',size);
            
            if($('.sidr-open')){
                $('.ugaheader').show();
            }else{
                $('.ugaheader').hide();
            }

		} else {

			$('#masthead, .sidr, .search--header').removeClass('sticky');
			$('body').removeClass('sticky');
            $('#page').css('margin-top','');
//			$('.ugaheader').fadeIn(100);
            $('.ugaheader').show();
		}

	};
    

	/* Document Ready */
	$(document).ready(function() {
		getWindowSize();
        equalheight('.vertical_center');
        
        AOS.init({
            duration: 400,
            once: true,
        });
        
        stickyNav();
        breakdownTabs();
        deadlineTabs();
        deadlinesList();
        
        //Accordion
        $('.accordion').find('.accordion--toggle').on('click', function(e) {
            e.preventDefault();
            $(this).parent().toggleClass('open');
            $(this).next().slideToggle('fast');
        });
        
        
        //FAQs JS
        $('.js-faq-toggle-trigger').each(function(){
            var $self = $(this);
            $self.on('click', function(e) {
                e.preventDefault();
                $(this).toggleClass('active').parent().toggleClass('active');
                $(this).next().slideToggle('fast').toggleClass('active');
            });
        });
        $('.js-faq-container').each(function(){
            var $self = $(this),
                $link = $( document.createElement('a') )
                    .attr('href','#')
                    .attr('class','expand-all')
                    .data('toggle-text', UGAFAQ.close_all_text )
                    .text( UGAFAQ.open_all_text )
                    .click(function(e){
                        e.preventDefault();
//							$self.find('.js-faq-toggle-trigger').click();

                        if($(this).data('toggle-text') == UGAFAQ.close_all_text){
                            $self.find('.js-faq-block').each(function(){
                                $(this).addClass('active').children('.js-faq-toggle-trigger').addClass('active');
                                $(this).children('.js-faq-toggle').slideDown('fast').addClass('active');
                            });
                        }else{
                            $self.find('.js-faq-block').each(function(){
                                $(this).removeClass('active').children('.js-faq-toggle-trigger').removeClass('active');
                                $(this).children('.js-faq-toggle').slideUp('fast').removeClass('active');
                            });
                        }

                        var new_data = $(this).text();
                        $(this).text($(this).data('toggle-text')).data('toggle-text',new_data);
                    });
                $(this).prepend( $link );
        });
        
        
        //Scholarship page Jump Links
        $('.scholarship-jump--links').find('.jumplinks--link').on('click', function(e) {
            e.preventDefault();
            var jumpId = $(this).attr('href');
            $('body, html').animate({scrollTop: $(jumpId).offset().top}, 'slow');
            
            var $link_text = $(this).text();
            $('#jumplink-links').slideToggle('fast');
            $('#jumplink-toggle').text($link_text);
        });
        
        $('#jumplink-toggle').on('click', function() {
            $('#jumplink-links').slideToggle('fast');
        });
        
        
        //Desktop Search Dropdown
        $('#menu-item-search').on('click',function(){
            $(this).toggleClass('active');
            $('.search--header').slideToggle();
        });
        
        //Sidr
        $('#mobile-trigger').sidr({
            side: 'left',
            name: 'sidr',
            displace: false,
            source : function() {
                return '<div id="mobile-menu"><div class="sidr__search">' + $('.search--header-google').html() + '</div><div class="sidr__inner">' + $('#site-navigation').html() + '</div></div>';
            },
            onOpen: function() {
                //alert('test');
                $( 'body' ).prepend( '<div class="sidr-overlay"></div>' );
                $('#mobile-trigger').hide();
                $('#mobile-close').show();
                
                $('#masthead').addClass('mobile');
                $('.ugaheader').show().addClass('mobile');
                
                $('.sidr__inner .sub-menu').find('.sub-menu').each(function() {
                    var menuId = $(this).parents('.menu-item-has-children').attr('id');
                    var parentLink = $(this).prevAll('a').attr('href');
                    var parentText = $(this).prevAll('a').html();
//                    alert(menuId);
                    $(this).attr('id','sidr-'+menuId).prepend('<li class="sidr__menu-back" data-sidr-menu="sidr-'+menuId+'">Back</li><li class="sidr__sub-menu-parent"><a href="'+parentLink+'">'+parentText+'</a></li>');
                });
                
                $('.sidr__search').find('.gsc-input ').attr("placeholder", "Search...");
            },
            onOpenEnd: function(){
                $( 'body' ).css({
////                    "position": "fixed",
//                    "left": "0",
////                    "top": "0",
                    "height": "100%",
                    "overflow": "hidden"
                });
                arrowClicks();
            },
            onClose: function(){
                $( '.sidr-overlay' ).remove();
                $('#mobile-trigger').show();
                $('#mobile-close').hide();
                $('#masthead, .ugaheader').removeClass('mobile');
                
                if($(window).scrollTop() != 0){
                    $('.ugaheader').hide();
                }
            },
            onCloseEnd: function(){
                $( 'body' ).css({
//                    "position": "relative",
//                    "left": "auto",
//                    "top": "auto",
                    "height": "auto",
                    "overflow": "visible"
                });
                $('.sidr__inner .sub-menu').find('.sub-menu').each(function() {
//                    alert(parentLink);
                    $(this).find('.sidr__menu-back').remove();
                    $(this).find('.sidr__sub-menu-parent').remove();
                });
            }
        });

        $('#mobile-close').click(function() {
            $.sidr('close','sidr');
            $('.nav-menu li .arrow').unbind();
        });
        
        
        /* YOUTUBE VIDEO EMBED */
        var $video_icon = $('.video_icon');
        if ($video_icon.length) {
            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            $video_icon.on("click", function() {
                var $this = $(this),
                    $youtube_id = $(this).data('youtubeid'),
                    $video_id = $(this).data('videoid'),
                    $parent = $(this).parents('.video_parent');
                $this.fadeOut(300);
                $this.parent('.video--content').fadeOut(300);
                player = new YT.Player($video_id, {
                    videoId: $youtube_id,
                    height: $parent.outerHeight(),
                    width: $parent.outerWidth(),
                    playerVars: {rel: 0},
                    events: {
                        'onReady' : onPlayerReady
                    }
                });

            });
        }

        function onPlayerReady(event) {
            event.target.playVideo();
        }

        /*
         * Countdown Timer
         */
        if( window.UGACountdowns && UGACountdowns.length > 0 ){
        	setupCountdown();
        }else{
        	$('.countdown_timer').hide();
        }
        
        
	});
    
    $(window).on('load', function() {
        
        if($('.search--header-google .gsc-input').length){
            $('.search--header-google').find('.gsc-input').attr("placeholder", "Search...");
        }
    });

	$(window).on("resize", function() {
		getWindowSize();
        equalheight('.vertical_center');
        deadlinesList();
        stickyNav();
        
        if(viewportwidth < 1200){
            if( $('.search--header').css('display') == 'block' ) {
                $('.search--header').hide();
                $('.search--toggle').removeClass('active');
            }
        }
        
        if(viewportwidth >= 1200){
            $.sidr('close','sidr');
            $('.nav-menu li .arrow').unbind();
        }
    
	});
    
    $(window).scroll(function() {
		stickyNav();
	});

})(jQuery);